import { todayLocalISO } from "../utils/dateUtils";
// src/constants/sondaConstants.js

export const SONDA_HORIZON_TEMPLATE = {
  no: 1,
  sembol: "",
  derinlik_min: 0,
  derinlik_max: "",

  // Fiziksel & Kimyasal
  tekstur: "",
  kirec: "",

  // Renkler (Munsell)
  renk_sinif_kuru: "", // Hue (Örn: 10YR)
  renk_kod_kuru: "", // Value/Chroma (Örn: 5/3)
  renk_sinif_yas: "",
  renk_kod_yas: "",

  // Diğer
  gozlem: "",
};

export const INITIAL_SONDA_DATA = {
  // --- SİSTEM & OPERASYONEL ---
  job_id: null,
  calismanin_adi: "",
  sonda_tipi: "Örnek",
  sehir: "", // Projeden otomatik gelen il bilgisi
  status: "pending",
  horizon_sayisi: 1,

  // --- KİMLİK & NUMARALANDIRMA ---
  sonda_no: "",
  grup_no: "",
  cuval_no: "",
  alma_sirasi: "",
  tarih: todayLocalISO(),
  ornegi_alan: "",
  benzer_profil: "",

  // --- KONUM (GPS) ---
  koordinat_x: "", // Enlem
  koordinat_y: "", // Boylam

  // --- TOPRAK KARAKTERİSTİĞİ (JEOLOJİ) ---
  ana_materyal: "",
  btg: "", // Büyük Toprak Grubu
  fizyografya: "",

  // --- TOPOĞRAFYA & SU ---
  egim: "",
  derinlik: "", // Toplam derinlik (cm)
  drenaj: "",
  su_erozyonu: "",

  // --- YÜZEY ÖZELLİKLERİ ---
  taslilik: "",
  cakillilik: "",
  kayalilik: "",
  urun: "", // Arazi Kullanımı / Ürün

  // --- NOTLAR ---
  gozlemler: "", // Genel gözlemler ve notlar
  // koordinat_x / koordinat_y yukarida "KONUM (GPS)" bolumunde tanimli;
  // burada tekrar edilince aciklama satirlari olan ilk tanimlari eziyordu.
  yukseklik: "", // YENİ EKLENDİ (Z)
  il: "", // YENİ EKLENDİ
  ilce: "", // YENİ EKLENDİ
  mahalle: "", // YENİ EKLENDİ
  arazi_kullanim_sinif: "", // YENİ EKLENDİ
  // --- KATMANLAR ---
  horizons: [{ ...SONDA_HORIZON_TEMPLATE }],
};
